/**
 * @name product
 *
 * @description
 * Insert any utilities about products here.
 */
import {ProductType} from '_types'

export const isShopByLook = (product: ProductType) => product.type?.set === true
